<template>
    <strong class="text-danger">&bullet;</strong>
</template>

<script>
export default {
    name: 'AlzataRequiredIndicator',
};
</script>